// extracted by mini-css-extract-plugin
module.exports = {"modalBg":"DiagramModal_modalBg__2HZ-W","modalBody":"DiagramModal_modalBody__2l5qH","notif":"DiagramModal_notif__3uyI9","loaderNotif":"DiagramModal_loaderNotif__3wg-w"};